<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Ihre Aussicht. Unser Handwerk.</h2>
        <div class="flex justify-center">
          <h1 class="headline">Balkongeländer</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Ein Balkon ist Rückzugsort, Lieblingsplatz und Freiluftwohnzimmer in einem. Damit Sie sich dort sicher und rundum wohlfühlen, bauen wir Balkongeländer, die mehr können als nur absichern: Sie schützen, gestalten und passen sich genau Ihrem Stil an.
        </p>

        <p class="mt-4 text-gray-700">
          Ob blickdicht mit gekanteten Blechkassetten, satiniertem Glas, Holz- oder Aluminiumlamellen oder luftig mit klaren Glasscheiben, senkrechten, waagerechten oder sogar wild versetzten Stacheten: Wir setzen Ihre Wünsche präzise um. Jedes Geländer entsteht in sorgfältiger Maßarbeit, angepasst an Haus, Umgebung und Nutzungswünsche.
        </p>

        <p class="mt-4 text-gray-700">
          Auch bei der Oberfläche haben Sie die Wahl: verzinkt, pulverbeschichtet oder in Edelstahl. Stets robust, langlebig und witterungsbeständig. Und wenn Sie sich vorab ein realistisches Bild machen wollen: Mit unserem Online-Konfigurator stellen Sie Ihr Wunschgeländer direkt auf unserer Website zusammen – inklusive Preisrahmen. So geht Planung heute: einfach, schnell und transparent.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Balkongeländer" pixelEvent="FormBalkongelaenderSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/balkongelaender/1.jpg", alt: "Balkongeländer 1" },
        { src: "img/produkte/balkongelaender/2.jpg", alt: "Balkongeländer 2" },
        { src: "img/produkte/balkongelaender/3.jpg", alt: "Balkongeländer 3" },
        { src: "img/produkte/balkongelaender/4.jpg", alt: "Balkongeländer 4" },
        { src: "img/produkte/balkongelaender/5.jpg", alt: "Balkongeländer 5" },
        { src: "img/produkte/balkongelaender/6.jpg", alt: "Balkongeländer 6" },
        { src: "img/produkte/balkongelaender/7.jpg", alt: "Balkongeländer 7" },
        { src: "img/produkte/balkongelaender/8.jpg", alt: "Balkongeländer 8" },
        { src: "img/produkte/balkongelaender/9.jpg", alt: "Balkongeländer 9" },
        { src: "img/produkte/balkongelaender/10.jpg", alt: "Balkongeländer 10" },
        { src: "img/produkte/balkongelaender/11.jpg", alt: "Balkongeländer 11" },
        { src: "img/produkte/balkongelaender/12.jpg", alt: "Balkongeländer 12" },
        { src: "img/produkte/balkongelaender/13.jpg", alt: "Balkongeländer 13" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
